export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00024.03bc0da2.png";